module.exports = {"451229100":"大化镇","451229101":"都阳镇","451229102":"岩滩镇","451229103":"北景镇","451229200":"共和乡","451229201":"贡川乡","451229202":"百马乡","451229203":"古河乡","451229204":"古文乡","451229205":"江南乡","451229206":"羌圩乡","451229207":"乙圩乡","451229210":"板升乡","451229211":"七百弄乡","451229213":"雅龙乡","451229214":"六也乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451229.json
// module id = 1992
// module chunks = 0